import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import api from '../../services/api';
import PasswordInput from '../PasswordInput';
import SmsConsentCheckbox from '../SmsConsentCheckbox';

function CreateMemberModal({ onClose, onCreated }) {
  const [form, setForm] = useState({
    username: '',
    email: '',
    phone: '',
    password: '',
    confirmPassword: '',
    authMethod: 'email',
    smsConsent: false,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(null);

  const set = (key) => (e) => setForm(f => ({ ...f, [key]: e.target.type === 'checkbox' ? e.target.checked : e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    if (!form.email && form.authMethod === 'email') {
      setError('Email is required for email authentication');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const response = await api.post('/family/members/create', {
        username: form.username,
        email: form.email || undefined,
        phone: form.phone || undefined,
        password: form.password,
        authMethod: form.authMethod,
        smsConsent: form.smsConsent,
      });
      setSuccess(response.data);
      onCreated && onCreated(response.data);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to create account. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    width: '100%', padding: '0.5rem', borderRadius: '4px',
    border: '1px solid #ddd', boxSizing: 'border-box',
  };

  return ReactDOM.createPortal(
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()} style={{ maxWidth: '480px', maxHeight: '90vh', overflowY: 'auto' }}>
        <div className="modal-header">
          <h3>Create Account for Someone</h3>
          <button onClick={onClose}>&#10005;</button>
        </div>
        <div style={{ padding: '1.5rem' }}>
          {success ? (
            <div style={{ textAlign: 'center' }}>
              <p style={{ marginBottom: '0.75rem' }}>Account created for <strong>{success.username}</strong>!</p>
              <p style={{ fontSize: '0.875em', opacity: 0.8, marginBottom: '1.25rem' }}>
                They've been added to your family. Share the login credentials with them.
                They'll be prompted to change their password on first login.
              </p>
              <button className="btn-save" onClick={onClose}>Done</button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
              <div style={{ background: '#fffbeb', border: '1px solid #fcd34d', borderRadius: '6px', padding: '0.6rem 0.75rem', fontSize: '0.8em' }}>
                This person will be prompted to change their password when they first log in.
              </div>

              <div>
                <label style={{ display: 'block', marginBottom: '0.25rem', fontSize: '0.875em' }}>Username *</label>
                <input value={form.username} onChange={set('username')} required style={inputStyle} placeholder="grandma_rose" />
              </div>

              <div>
                <label style={{ display: 'block', marginBottom: '0.25rem', fontSize: '0.875em' }}>Authentication method</label>
                <select value={form.authMethod} onChange={set('authMethod')} style={inputStyle}>
                  <option value="email">Email</option>
                  <option value="sms">SMS / Phone</option>
                </select>
              </div>

              {form.authMethod === 'email' ? (
                <div>
                  <label style={{ display: 'block', marginBottom: '0.25rem', fontSize: '0.875em' }}>Email *</label>
                  <input type="email" value={form.email} onChange={set('email')} required style={inputStyle} placeholder="rose@example.com" />
                </div>
              ) : (
                <>
                  <div>
                    <label style={{ display: 'block', marginBottom: '0.25rem', fontSize: '0.875em' }}>Phone *</label>
                    <input type="tel" value={form.phone} onChange={set('phone')} required style={inputStyle} placeholder="+1 555 000 0000" />
                  </div>
                  <SmsConsentCheckbox
                    checked={form.smsConsent}
                    onChange={(checked) => setForm(f => ({ ...f, smsConsent: checked }))}
                  />
                </>
              )}

              <div>
                <label style={{ display: 'block', marginBottom: '0.25rem', fontSize: '0.875em' }}>Password *</label>
                <PasswordInput value={form.password} onChange={set('password')} placeholder="Set a password" />
              </div>

              <div>
                <label style={{ display: 'block', marginBottom: '0.25rem', fontSize: '0.875em' }}>Confirm Password *</label>
                <PasswordInput value={form.confirmPassword} onChange={set('confirmPassword')} placeholder="Confirm password" />
              </div>

              {error && <p style={{ color: 'red', fontSize: '0.875em' }}>{error}</p>}

              <div style={{ display: 'flex', gap: '0.75rem', marginTop: '0.25rem' }}>
                <button type="button" onClick={onClose} style={{ flex: 1, padding: '0.5rem', border: '1px solid #ddd', borderRadius: '6px', background: 'none', cursor: 'pointer' }}>
                  Cancel
                </button>
                <button type="submit" className="btn-save" disabled={loading} style={{ flex: 1 }}>
                  {loading ? 'Creating…' : 'Create Account'}
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
}

export default CreateMemberModal;
